import React from 'react';

import LogoImage from 'assets/images/logo.png';

import { Container, LogoContainer } from './styles';

export const ServiceLayout = ({
  children,
}: React.PropsWithChildren<unknown>) => {
  return (
    <Container>
      <LogoContainer src={LogoImage} />
      {children}
    </Container>
  );
};
